import React, { useEffect, useState } from 'react';
import { Navbar, Container, Button, Image } from 'react-bootstrap';
import { useLocation, Link, useHistory } from 'react-router-dom';
import { flatMap, map, find, some } from 'lodash';
import { handleCheckDynamicRoutes } from 'Utils/Route';
import { default as LogoutConfirmationModal } from 'Components/Common/Modal';

import { MENUS } from 'Constant/Menu';
import { useAppDispatch, useAppSelector } from 'App/Store';
import { logout } from 'App/Features/Auth';
import { BoxArrowRight } from 'react-bootstrap-icons';
import Logo from 'Static/Images/logo.png';
import { setTitlePage } from 'App/Features/Layout';

import { resetRevenueFilters } from 'App/Features/Revenue';

const Header = (): JSX.Element => {
  const location = useLocation();
  const history = useHistory();

  const dispatch = useAppDispatch();

  const {
    auth: { company, email },
    layout: { titlePage },
  } = useAppSelector((state) => state);

  const [showLogoutConfirmationModal, setShowLogoutConfirmationModal] = useState(false);

  const handleCheckMatchLink = () => {
    let title = '';
    const flatMenus = flatMap(MENUS, (menu) => map(menu.children, (sub) => ({ ...sub })));
    const onSideBarCondition = some(flatMenus, (menu) => menu.slug === location.pathname);
    if (onSideBarCondition) {
      title = find(flatMenus, (menu) => menu.slug === location.pathname)?.title ?? '';
    } else {
      title = handleCheckDynamicRoutes(location)?.title ?? '';
    }
    if (!title) return;
    dispatch(setTitlePage(title));
  };

  useEffect(() => {
    handleCheckMatchLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleLogout = () => {
    dispatch(resetRevenueFilters());
    dispatch(logout());
    history.push('/login');
  };

  return (
    <>
      <LogoutConfirmationModal
        show={showLogoutConfirmationModal}
        onCloseModal={() => setShowLogoutConfirmationModal(false)}
        onSubmitModal={handleLogout}
        cancelText="キャンセル"
        confirmText="ログアウトする"
        title="ログアウト確認"
        classNameContent="d-flex align-items-center content-body-modal justify-content-center"
      >
        <div>ログアウトします。よろしいですか。</div>
      </LogoutConfirmationModal>
      <Navbar className="header-top header-bg">
        <Container fluid>
          <div className="d-flex align-items-center w-100">
            <div className="px-sm-2 px-0 sidebar">
              <Link
                to="/"
                className="w-100 d-flex align-items-center text-white text-decoration-none fw-bold"
              >
                <span className="fs-14 d-none d-sm-inline">
                  <Image src={Logo} className="img-logo ps-4" />
                </span>
              </Link>
            </div>
            <div className="pt-1 d-flex w-100">
              <Navbar.Brand href="#" className="text-white  fs-14 fw-bold">
                {titlePage}
              </Navbar.Brand>
              <Navbar.Toggle />
              <Navbar.Collapse className="justify-content-end">
                <Navbar.Text className="text-white">
                  <span className="ms-2 me-3">BootRock管理画面</span>
                </Navbar.Text>
              </Navbar.Collapse>

              <Navbar.Collapse className="justify-content-end">
                <Navbar.Text className="text-white me-3">
                  <span className="me-2">{company}</span>|<span className="ms-2 me-3">{email}</span>
                </Navbar.Text>
                <Button
                  variant="link"
                  onClick={() => setShowLogoutConfirmationModal(true)}
                  className="text-white me-3 logout"
                >
                  <BoxArrowRight /> ログアウト
                </Button>
              </Navbar.Collapse>
            </div>
          </div>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
